/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	'use strict';
	
	var _keys = __webpack_require__(9);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _queryBuilderGroupDirective = __webpack_require__(36);
	
	var _queryBuilderGroupDirective2 = _interopRequireDefault(_queryBuilderGroupDirective);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	    'use strict';
	
	    queryBuilderGroup.$inject = ["$compile"];
	    angular.module('ngQueryBuilder', []).directive('queryBuilder', queryBuilder).directive('queryBuilderGroup', queryBuilderGroup).directive('attrs', attrs);
	
	    function queryBuilder() {
	        return {
	            restrict: 'AE',
	            scope: {
	                options: '=queryBuilder',
	                templateUrl: '=?'
	            },
	            template: '<div query-builder-group="options" group="options._query.group"></div>',
	            link: function link(scope) {
	                var defaults = {
	                    operators: [{ name: 'AND', value: '$and' }, { name: 'OR', value: '$or' }],
	                    conditions: [{ name: 'equal', value: '$eq' }, { name: 'is not equal', value: '$neq' }, { name: 'less than', value: '$lt' }, { name: 'less than or equal', value: '$lte' }, { name: 'greater than', value: '$gt' }, { name: 'greater than or equal', value: '$gte' }],
	                    templateUrl: scope.templateUrl
	                };
	
	                scope.options = angular.extend({}, defaults, scope.options);
	
	                scope.options._query = {
	                    group: {
	                        operator: scope.options.operators[0],
	                        rules: []
	                    }
	                };
	
	                scope.format = format;
	
	                function format(group) {
	                    var rulesWrapper = [];
	                    var operatorsWrapper = {};
	
	                    for (var i = 0; i < group.rules.length; i++) {
	                        operatorsWrapper[group.operator.value] = rulesWrapper;
	
	                        if (group.rules[i].group) {
	                            rulesWrapper.push(format(group.rules[i].group));
	                        } else {
	                            var el = {};
	                            el[group.rules[i].field.value] = {};
	                            el[group.rules[i].field.value][group.rules[i].condition.value] = group.rules[i].data;
	                            rulesWrapper.push(el);
	                        }
	                    }
	
	                    var firstKey = (0, _keys2.default)(operatorsWrapper)[0];
	
	                    if (firstKey && operatorsWrapper[firstKey].length < 2) {
	                        operatorsWrapper = operatorsWrapper[firstKey].pop();
	                    }
	
	                    return operatorsWrapper;
	                }
	
	                scope.$watch('options._query', function (query) {
	                    scope.options.query = scope.format(query.group);
	                }, true);
	            }
	        };
	    }
	
	    function queryBuilderGroup($compile) {
	        'ngInject';
	
	        return {
	            restrict: 'AE',
	            scope: {
	                group: '=',
	                options: '=queryBuilderGroup'
	            },
	            template: '<div ng-include="getTemplate()"></div>',
	            compile: function compile(tElement) {
	                var compiledContents = void 0;
	                var content = tElement.contents().remove();
	
	                return function (scope, iElement) {
	                    scope.addCondition = addCondition;
	                    scope.removeCondition = removeCondition;
	                    scope.addGroup = addGroup;
	                    scope.removeGroup = removeGroup;
	                    scope.getTemplate = getTemplate;
	
	                    function addCondition() {
	                        scope.group.rules.push({
	                            condition: scope.options.conditions[0],
	                            field: scope.options.fields[0],
	                            data: ''
	                        });
	                    }
	
	                    function removeCondition(index) {
	                        scope.group.rules.splice(index, 1);
	                    }
	
	                    function addGroup() {
	                        scope.group.rules.push({
	                            group: {
	                                operator: scope.options.operators[0],
	                                rules: []
	                            }
	                        });
	                    }
	
	                    function removeGroup() {
	                        'group' in scope.$parent && scope.$parent.group.rules.splice(scope.$parent.$index, 1);
	                    }
	
	                    function getTemplate() {
	                        return scope.options.templateUrl || _queryBuilderGroupDirective2.default;
	                    }
	
	                    if (!compiledContents) {
	                        compiledContents = $compile(content);
	                    }
	
	                    compiledContents(scope, function (clone) {
	                        iElement.append(clone);
	                    });
	                };
	            }
	        };
	    }
	
	    function attrs() {
	        return {
	            restrict: 'A',
	            scope: {
	                list: '=attrs'
	            },
	            link: function link(scope, element) {
	                scope.$watch('list', function (list) {
	                    for (var attr in scope.list) {
	                        element.attr(attr, scope.list[attr]);
	                    }
	                });
	            }
	        };
	    }
	})();

/***/ },
/* 1 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(3)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 3 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 5 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(22)
	  , defined = __webpack_require__(6);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	module.exports = { "default": __webpack_require__(10), __esModule: true };

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	__webpack_require__(35);
	module.exports = __webpack_require__(1).Object.keys;

/***/ },
/* 11 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var isObject = __webpack_require__(5);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(8)
	  , toLength  = __webpack_require__(31)
	  , toIndex   = __webpack_require__(30);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// optional / simple context binding
	var aFunction = __webpack_require__(11);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var isObject = __webpack_require__(5)
	  , document = __webpack_require__(4).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var global    = __webpack_require__(4)
	  , core      = __webpack_require__(1)
	  , ctx       = __webpack_require__(15)
	  , hide      = __webpack_require__(20)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 19 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var dP         = __webpack_require__(23)
	  , createDesc = __webpack_require__(27);
	module.exports = __webpack_require__(2) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	module.exports = !__webpack_require__(2) && !__webpack_require__(3)(function(){
	  return Object.defineProperty(__webpack_require__(16)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(14);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var anObject       = __webpack_require__(12)
	  , IE8_DOM_DEFINE = __webpack_require__(21)
	  , toPrimitive    = __webpack_require__(33)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(2) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var has          = __webpack_require__(19)
	  , toIObject    = __webpack_require__(8)
	  , arrayIndexOf = __webpack_require__(13)(false)
	  , IE_PROTO     = __webpack_require__(28)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(24)
	  , enumBugKeys = __webpack_require__(17);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(18)
	  , core    = __webpack_require__(1)
	  , fails   = __webpack_require__(3);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 27 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var shared = __webpack_require__(29)('keys')
	  , uid    = __webpack_require__(34);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var global = __webpack_require__(4)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	var toInteger = __webpack_require__(7)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__(7)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(6);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(5);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 34 */
/***/ function(module, exports) {

	
	/* injects from baggage-loader */
	
	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	
	/* injects from baggage-loader */
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(32)
	  , $keys    = __webpack_require__(25);
	
	__webpack_require__(26)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 36 */
/***/ function(module, exports) {

	var path = '/src/query-builder-group-directive.html';
	var html = "<div class=\"alert alert-info\"> <div class=form-inline> <select ng-options=\"o.name for o in options.operators track by o.value\" ng-model=group.operator class=\"form-control input-sm\"></select> <button ng-click=addCondition() class=\"btn btn-sm btn-success\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add Condition</button> <button ng-click=addGroup() class=\"btn btn-sm btn-success\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add Group</button> <button ng-click=removeGroup() class=\"btn btn-sm btn-danger\"><span class=\"glyphicon glyphicon-minus-sign\"></span> Remove Group</button> </div> <div class=query-builder-group> <div ng-repeat=\"rule in group.rules | orderBy:'index'\" class=query-builder-condition> <div ng-switch=\"rule.hasOwnProperty('group')\"> <div ng-switch-when=true> <div query-builder-group=options group=rule.group></div> </div> <div ng-switch-default> <div class=form-inline> <select ng-options=\"f.name for f in options.fields track by f.value\" ng-model=rule.field class=\"form-control input-sm\"></select> <select ng-options=\"c.name for c in options.conditions track by c.value\" ng-model=rule.condition class=\"form-control input-sm\"></select> <input type=text ng-model=rule.data class=\"form-control input-sm\" attrs=rule.field.attrs> <button ng-click=removeCondition($index) class=\"btn btn-sm btn-danger\"><span class=\"glyphicon glyphicon-minus-sign\"></span></button> </div> </div> </div> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** angular-query-builder.js
 **/